import { jsxs as d, jsx as m } from "react/jsx-runtime";
import { Checkbox as l } from "antd";
import { memo as x, useCallback as f } from "react";
import { l as u } from "../../../../lodash-DeBCDn4U.js";
import { u as e } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { GAInput as k } from "@biron-data/react-components";
const A = x(({
  value: s,
  onChange: t,
  activated: p = !0,
  defaultLabel: r,
  gaevent: c
}) => {
  const o = f((i) => {
    i.target.checked && r ? t == null || t(r) : t == null || t(void 0);
  }, [r, t]);
  return /* @__PURE__ */ d(v, { children: [
    /* @__PURE__ */ m(l, { checked: !u.isEmpty(s), onChange: o }),
    /* @__PURE__ */ m(
      k,
      {
        value: s ?? r,
        type: void 0,
        onChange: (i) => t == null ? void 0 : t(i.target.value),
        disabled: !p || !s,
        gaevent: c
      }
    )
  ] });
}), v = e.div`
  display: flex;
  gap: 8px;
`;
export {
  A as default
};
//# sourceMappingURL=CustomDisplaySelector.js.map
